import { combineReducers } from 'redux';
import { events } from './events';
import { eventDetail } from '../galleryItemDetail';

export const gallery = combineReducers({
  events,
  eventDetail
});